<template>
  <modal
    :showModal="showModal"
    v-loading="loading"
    @close-modal="$emit('close-modal')"
    width="60"
  >
    <div class="my-2">
      <p class="w-full bg-gray-200 p-3">Search Public Fleets</p>
      <div class="w-full flex mt-3">
        <div class="table__search-input-wrapper w-full opacity-75">
          <span class="pr-2 opacity-50"><search-icon /> </span>

          <input
            type="text"
            class="table__search-input w-full"
            placeholder="Search..."
            v-model="searchParams"
          />
          <img
            @click="showFilterModal = true"
            class="cursor-pointer"
            src="@/assets/images/icons/search.svg"
            alt="search icon"
          />
        </div>
      </div>

      <table class="custom-table responsive-table">
        <thead>
          <tr class="shadow-table rounded-lg">
            <th><base-checkbox /> Fleet Name</th>
            <th>Vehicle Type</th>
            <th>Loading Capacity</th>
            <th>Route</th>
            <th>3PL Owner</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="shadow-table rounded-lg"
            v-for="fleet in publicFleet"
            :key="fleet.id"
          >
            <td>
              <base-checkbox @change="onCheckFleet($event, fleet.id)" />{{
                fleet.equipment ? fleet.equipment : "N/A"
              }}
            </td>

            <td>{{ fleet.vehicletype ? fleet.vehicletype : "N/A" }}</td>

            <td class="text-primary-yellow font-semibold">
              {{
                fleet.currentLoadCapacity ? fleet.currentLoadCapacity : "N/A"
              }}
              Tonnes
            </td>

            <td>
              {{ fleet.route ? fleet.route.routeName : "N/A" }}
            </td>

            <td class="update" @click="addParticular('licenseAndRegistration')">
              MuleEx
            </td>
            <td class="update">
              <img
                src="@/assets/images/icons/info.svg"
                alt="information icon"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="flex justify-end items-center mt-12">
        <button class="mr-16">Cancel</button>
        <base-button
          class="px-4 py-2 bg-primary-yellow"
          text="Save"
          :disabled="!selectedFleet.length"
          @click="savePublicFleet"
          :loading="loading"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import debounce from "@/utilities/debounce";
export default {
  props: {
    showModal: Boolean,
  },
  data() {
    return {
      publicFleet: [],
      selectedFleet: [],
      loading: false,
      searchParams: ""
    };
  },
  computed: {
    payload() {
      let user = JSON.parse(localStorage.getItem("loggedInUser"));
      return {
        fleets: this.selectedFleet,
        orgId: user.orgId,
        userId: user.id,
      };
    },
    getFleetPayload(){
      let user = JSON.parse(localStorage.getItem("loggedInUser"));
       return {
        pageNumber: 1,
        pageSize: 10,
        searchTerm: this.searchParams,
        orgId: user.orgId,
       }
    }
  },
  watch: {
    showModal(val) {
      val ? this.getAllPublicFleet() : null;
    },
    "getFleetPayload":debounce(function(){
        this.getAllPublicFleet()
      }, 500)
    },
  methods: {
    onCheckFleet(event, val) {
      this.appendPublicFleet(val, event);
    },
    appendPublicFleet(val, event) {
      event
        ? this.selectedFleet.push(val)
        : (this.selectedFleet = this.selectedFleet.filter(
            (item) => item !== val
          ));
    },
   async  savePublicFleet() {
      this.loading = true;
      try {
        await this.$_addPublicFleet(this.payload)
        .then(() =>
          this.$emit("close-modal")
        );
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
    getAllPublicFleet() {
      try {
        this.$_getAllPublicFleet(this.getFleetPayload).then(
          (res) => (this.publicFleet = res.data.data)
        );
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
</style>
